module.exports = __webpack_public_path__ + "img/logo-full.a6cc3ab.svg";